<template>
  <div id="app" class="row vert-offset-top-2">
    <div class="row justify-content-center">
      <div class="row col s12">
        <div class="row col s12">
          <div class="row col s12">
            <div class="row col s12">
              <div class="row col s12 ">
                <div class="row col s12 m10 l8 offset-m1 offset-l2">
                  <div
                    id="card"
                    class="row card col s12 vert-offset-top-1  z-depth-3 "
                  >
                    <div
                      class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
                    >
                      <h6>Appointment</h6>
                    </div>
                    <div
                      class="row vert-offset-top-half vert-offset-bottom-half"
                    >
                      <div
                        class="col s12 vert-offset-top-half padding-bottom-half grey-text text-darken-2"
                      >
                        Which date & time do you wish to book for?
                      </div>

                      <div class="col s12">
                        <vue-ctk-date-time-picker
                          format="YYYY-MM-DD H:m"
                          style="content: inherit;"
                          color="orange"
                          v-model="date"
                          class="col s12  m10 l8 offset-m1 offset-l2 "
                        ></vue-ctk-date-time-picker>
                      </div>
                    </div>
                    <div
                      class="col s12 padding-bottom-half vert-offset-top-2 grey-border border-top-1 border-lighten-3 padding-top-1"
                    >
                      <div class="col s4 padding-bottom-1 padding-top-1">
                        <button
                          @click.prevent="goback"
                          class="btn btn-small block orange darken-1  white-text col s12 "
                        >
                          back
                        </button>
                      </div>
                      <div
                        class="col s4 offset-s4  padding-bottom-1 padding-top-1 "
                      >
                        <button
                          @click.prevent="goto"
                          class="btn btn-small btn-block orange darken-1  white-text col s12 "
                          :disabled="!isValidDate"
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http-common";
import { mapState } from "vuex";
import moment from "moment";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  name: "Schedule",
  components: {
    VueCtkDateTimePicker
  },
  data() {
    return {
      date: "",
      selected_location_key: ""
    };
  },
  methods: {
    goto() {
      this.$store.dispatch("START_PROCESSING");
      this.$store.dispatch("SET_DATE", this.date);
      this.$store.dispatch("STOP_PROCESSING");
      this.$router.push("/reason");
    },
    goback() {
      this.$router.push("/selectcenter");
    },

    saveSchedule() {
      this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "",
          data: {},
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            this.$store.dispatch("STOP_PROCESSING");
            //this.roles = response.data.data;
            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    },
    emitEventChanged() {
      this.$store.commit("initialiseStore", this.date);
    }
  },
  watch: {
    dates(newDates) {
      localStorage.date = JSON.stringify(newDates);
    }
  },
  created() {
    this.emitEventChanged();
  },
  beforeCreate() {
    this.$store.commit("initialiseStore", this.date);
  },
  mounted() {
    if (this.stateHasSelectedDate) {
      this.date = this.stateSelectedDate;
    }
  },
  computed: {
    ...mapState({
      stateSelectedDistrict: state => state.selectedDistrict,
      stateSelectedCenter: state => state.selectedCenter,
      stateSelectedLocation: state => state.selectedLocation,
      stateSelectedDate: state => state.date
    }),
    stateHasSelectedDate: function() {
      return (
        typeof this.stateSelectedDate !== "undefined" &&
        this.stateSelectedDate !== null
      );
    },
    stateHasSelectedDistrict: function() {
      return (
        typeof this.stateSelectedDistrict !== "undefined" &&
        this.stateSelectedDistrict !== null
      );
    },
    stateHasSelectedLocation: function() {
      return (
        typeof this.stateSelectedLocation !== "undefined" &&
        this.stateSelectedLocation !== null
      );
    },
    stateHasSelectedCenter: function() {
      return (
        typeof this.stateSelectedCenter !== "undefined" &&
        this.stateSelectedCenter !== null
      );
    },
    isValidDate: function() {
      return moment(this.date) >= moment();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-kerning: normal;
}
#datetimepicker1 {
  height: 20em;
  content: inherit;
}
</style>
